import { useMutation } from '@tanstack/react-query';
import {
  TransferWithEvidenceService,
  ApproveTransferRequestDto,
  ApproveTransferRequestEntity,
} from 'services/openapi';

export const useApproveTransferRequestMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<ApproveTransferRequestEntity, Error, ApproveTransferRequestDto>(
      {
        mutationFn: (variables: ApproveTransferRequestDto) =>
          TransferWithEvidenceService.transferWithEvidenceControllerBidvApprove(
            variables,
          ),
      },
    );

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};
